/**
 * Coups de pouce — Attendu 1041 « Utiliser les tables de multiplication pour
 * factoriser » (automatisme 5e, déclaratif : 42 doit ÉVOQUER 6 × 7).
 *
 * Le coup de pouce n'est pas une méthode de récupération (il n'y en a pas :
 * l'élève sait ou ne sait pas) : il redescend d'un cran sur l'échelle Eduscol
 * (N3 → N2, « dans quelle table chercher et comment la remonter ») ou donne
 * la checklist de JUGEMENT des QCM. Un élève qui l'ouvre à chaque item est à
 * N2 : donnée diagnostique, pas un échec de la fiche.
 *
 * EXEMPLE UNIQUE : 15 = 3 × 5, le nombre SACRIFIÉ (cf. NOMBRE_SACRIFIE dans
 * gen_1041 : 15 ne sort jamais en tirage, 25 est banni des paires de la
 * table commune) : l'aide ne peut jamais souffler un tirage courant.
 * Invariant protégé par cdp1041.self.test.js.
 *
 * decomposable_vf : PAS d'entrée (pur rappel, précédent gen_640 et V/F de
 * 1040) : tout indice utile serait un test de la notion interdite ; le
 * retour vit dans contenu.explications par ligne (décomposition trouvée ou
 * « aucune table de 2 à 10 ne donne 23 »), affichage = chantier UI séparé.
 */

// EXEMPLE MODÉLISANT PUR (revue 2026-08-31) : pas de règle au-dessus, la
// table écrite en entier FAIT le geste : l'élève voit où s'arrêter et lit
// la réponse à côté du ×. « Fais pareil avec ton nombre » dit que c'est un
// modèle à imiter, pas la correction d'un autre exercice.
const FICHE_LIRE_TABLE = {
    pages: [
        {
            titre: 'Fais pareil avec ton nombre',
            lignes: [
                '15 = 5 × ?',
                'Je dis la table de 5 jusqu\'à 15 :',
                '5 × 1 = 5',
                '5 × 2 = 10',
                '**5 × 3 = 15** ← c\'est là !',
                'Donc **15 = 5 × 3**.',
            ],
        },
    ],
};

const FICHE_VERIFIER = {
    pages: [
        {
            titre: 'Fais pareil avec ton nombre',
            lignes: [
                'Pour 15, je vérifie chaque écriture :',
                '10 + 5 → il y a un +, ce n\'est pas une multiplication ❌',
                '1 × 15 → il y a le chiffre 1 ❌',
                '3 × 6 = 18 → ce n\'est pas 15 ❌',
                '**3 × 5 = 15** ✅',
            ],
        },
    ],
};

const FICHE_ETRE_DANS_TABLE = {
    pages: [
        {
            titre: 'Fais pareil avec ton nombre',
            lignes: [
                '15 est-il dans la table de 5 ? **5, 10, 15** → oui ✅',
                '15 est-il dans la table de 4 ? 4, 8, 12, 16 → non, je l\'ai dépassé ❌',
                '15 et 25 dans une même table ? Dans la **table de 5**, j\'entends les deux ✅',
            ],
        },
    ],
};

const CP_1041 = {
    facteur_texte_trou_saisie: FICHE_LIRE_TABLE,
    decomposition_qcm: FICHE_VERIFIER,
    decompositions_qcm_multi: FICHE_VERIFIER,
    tables_qcm_multi: FICHE_ETRE_DANS_TABLE,
    table_commune_saisie: FICHE_ETRE_DANS_TABLE,
};

export default CP_1041;
